import { TooltipItem } from "chart.js";
import { DatasetDataItem } from "../types";
import { roundNumber } from "@common/utils/roundNumber";

export const getTooltipLabel =
  (unitMeasurement: string) => (tooltipItem: TooltipItem<"line">) => {
    const { y } = tooltipItem.raw as DatasetDataItem;
    const roundedValue = roundNumber(y ?? 0);

    if (unitMeasurement) return `${roundedValue} ${unitMeasurement}`;

    return String(roundedValue);
  };
